export default async function getMyProjects(authHeader) {
  return fetch(
    `${process.env.REACT_APP_HELDR_API_URL}/me/projects`,
    { headers: authHeader },
  );
}
